import { isEmpty } from 'lodash';
import moment from 'moment';
export const globalApi = 'https://tcdforms.thecompletedivorce.com/api';
// export const globalApi = 'http://192.168.1.20:33333/api';
export const serverApi = `${globalApi}/forms`;

export function parseDate(date) {
    return isEmpty(date) ? "" : moment(date).format('MM-DD-YYYY');
}
export const insertToIndex = (arr, index, newItem) => [
    // part of the array before the specified index
    ...arr.slice(0, index),
    // inserted item
    newItem,
    // part of the array after the specified index
    ...arr.slice(index)
  ]